<template>
  <footer id="contact" class="gig-footer !text-slate-800 bg-gray-50 py-10">
    <div class="container mx-auto px-4">
      <div class="grid grid-cols-1 sm:grid-cols-12 gap-4 mb-8 gap-y-8 pt-4">
        <div class="col-span-4">
          <div class="flex items-center mb-4">
            <NuxtImg
              src="/img/logo/gig-logo.png"
              width="210"
              height="50"
              class="max-w-[150px] md:max-w-fit"
            />
          </div>
          <p class="text-slate-600 mb-4 max-w-md">
            Gigcep ile boş zamanlarınızı değerlendirin ve çeşitli gigleri
            tamamlayarak hediyeler kazanın.
          </p>
        </div>

        <div class="col-span-2">
          <h3 class="text-lg font-semibold mb-4 text-slate-900">
            Hızlı Bağlantılar
          </h3>
          <ul class="space-y-2">
            <li>
              <a href="#home" class="text-slate-600 transition-colors"
                >Ana Sayfa</a
              >
            </li>
            <li>
              <a href="#how-it-works" class="text-slate-600 transition-colors"
                >Nasıl Çalışır</a
              >
            </li>
            <li>
              <a href="#contact" class="text-slate-600 transition-colors">
                İletişim
              </a>
            </li>
            <li>
              <a
                href="#contact"
                class="text-slate-600 transition-colors"
                @click="openMobilAppUrl"
              >
                İndir
              </a>
            </li>
          </ul>
        </div>

        <div class="col-span-3">
          <h3 class="text-lg font-semibold mb-4 text-slate-900">Yasal</h3>
          <ul class="space-y-2">
            <li>
              <a
                href="https://gigcep.com/pages/Gigcep-Kullanici-Sozlesmesi"
                target="_blank"
                rel="noopener noreferrer"
                class="text-slate-600 transition-colors"
              >
                Kullanıcı Sözleşmesi
              </a>
            </li>
            <li>
              <a
                href="https://gigcep.com/pages/Gigcep-Gizlilik-Politikasi"
                target="_blank"
                rel="noopener noreferrer"
                class="text-slate-600 transition-colors"
              >
                Gizlilik Politikası
              </a>
            </li>
            <li>
              <a
                href="https://gigcep.com/pages/Gigcep-KVKK-Politikasi"
                target="_blank"
                rel="noopener noreferrer"
                class="text-slate-600 transition-colors"
              >
                KVKK Politikası
              </a>
            </li>
            <li>
              <a
                href="https://gigcep.com/pages/Gigcep-KVKK-Aydinlatma-Metni"
                target="_blank"
                rel="noopener noreferrer"
                class="text-slate-600 transition-colors"
              >
                KVKK Aydınlatma Metni
              </a>
            </li>
            <li>
              <a
                href="https://gigcep.com/pages/Gigcep-Acik-Riza-Metni"
                target="_blank"
                rel="noopener noreferrer"
                class="text-slate-600 transition-colors"
              >
                Açık Rıza Metni
              </a>
            </li>
            <li>
              <a
                href="https://gigcep.com/pages/Gigcep-Cerez-Politikasi"
                target="_blank"
                rel="noopener noreferrer"
                class="text-slate-600 transition-colors"
              >
                Çerez Politikası
              </a>
            </li>
          </ul>
        </div>

        <div class="col-span-3">
          <h3 class="text-lg font-semibold mb-4 text-slate-900">İletişim</h3>
          <ul class="space-y-3">
            <li class="flex items-start">
              <Icon name="bx:map" class="mr-2 size-7" style="color: #818cf8" />
              <span class="text-slate-600"
                >GİGDATA BİLGİ TEKNOLOJİLERİ LİMİTED ŞİRKETİ</span
              >
            </li>
            <li class="flex items-center">
              <Icon
                name="material-symbols:mail-outline"
                class="mr-2 size-7"
                style="color: #818cf8"
              />

              <a
                href="mailto:info@gigcep.com"
                class="text-slate-600 transition-colors"
              >
                info@gigcep.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="pt-8 border-t border-gray-800 text-center text-gray-500 text-sm"
      >
        <p>
          &copy; {{ new Date().getFullYear() }} GİGDATA BİLGİ TEKNOLOJİLERİ
          LİMİTED ŞİRKETİ. Tüm hakları saklıdır.
        </p>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
function openMobilAppUrl() {
  window.open(
    "https://play.google.com/store/apps/details?id=com.gigcep.app",
    "_blank",
  )
}
</script>

<style scoped lang="scss">
.gig-footer {
  a {
    transition: color 0.3s ease;
    &:hover {
      color: #0f172a;
    }
  }
}
</style>
